import React from 'react'
import { useSelector } from 'react-redux';
import { getUserSelector } from '../../../../../../../redux/reducers/reducerSlices/UserReducer';

const CSCEAgent = (props) => {

     const user = useSelector(getUserSelector);
    const {  userAccountDetails } = user;
    const finalURL = `${process.env.REACT_APP_CSCE_USER_BASEURL}?type=agent&cuid=${userAccountDetails.CUID}&email=${userAccountDetails.Email}&firstName=${userAccountDetails.FirstName}&lastName=${userAccountDetails.LastName}&phone=${userAccountDetails.Phone}&countyCode=+91`
    
  return (
      <div style={{flex: '1'}}>
          <iframe src={finalURL} frameborder="0" style={{width: '100%', height: '100%'}}></iframe>
    </div>
  )
}



export default CSCEAgent